"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayIteratorNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const uuidv4_1 = require("uuidv4");
const md5_1 = __importDefault(require("md5"));
const lodash_1 = require("lodash");
const NODE_TYPE = 'ARRAY-ITERATOR';
class ArrayIteratorNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params, _configFunctions, seedData) => {
            const { input } = params;
            this.iterate = true;
            const duplicateItemCount = {};
            return {
                output: (input || []).map(function (item, index) {
                    var _a;
                    const strItem = JSON.stringify(item);
                    const strHash = lodash_1.isNil(item) ? strItem : md5_1.default(strItem);
                    duplicateItemCount[strHash] = ((_a = duplicateItemCount[strHash]) !== null && _a !== void 0 ? _a : 0) + 1;
                    return {
                        output: item,
                        index: index,
                        id: (seedData === null || seedData === void 0 ? void 0 : seedData.seed) ? uuidv4_1.fromString(`${seedData.seed}-${strHash}-${duplicateItemCount[strHash]}`) : uuidv4_1.uuid(),
                    };
                }),
            };
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: {},
        };
        OutputParams.properties = {
            output: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
            index: { type: 'number', description: 'Index' },
            id: { type: 'string', description: 'New Id' },
        };
        const InputParams = {
            type: 'object',
            properties: {
                input: {
                    items: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Items to Iterate',
                    type: 'array',
                    title: 'input',
                },
            },
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: OutputParams, ConfigParams: {
                type: 'object',
                properties: {
                    type: BaseNode_1.BaseNode.getTypeOptions(false),
                },
            } });
    }
}
exports.ArrayIteratorNode = ArrayIteratorNode;
ArrayIteratorNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Array Iterator',
    isIdempotent: true,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ArrayIterator.js.map